import { render } from "./index.vue?vue&type=template&id=1ae20c9e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1ae20c9e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1ae20c9e"

export default script